import type { PartnerFeatures } from '../config/schema';
import { useBranding } from './BrandingProvider';

// Boolean lookup against partner.features. Use this everywhere a route or UI
// section is gated by partner-level feature availability:
//   const showShopify = useFeature('shopify');
// `keyof PartnerFeatures` is enforced at compile time — typos like
// useFeature('shopfy') won't typecheck.
export const useFeature = (feature: keyof PartnerFeatures): boolean =>
  useBranding().features[feature];
